import { useRef } from "react";
import { useQuery } from "react-query";
import { random } from "lodash";

import { QUERY_KEYS } from "../constants";
import api from "../api";

const client = api();

const getRotatedAdProduct = (adProducts = [], randNum) =>
  adProducts.find(
    (adProduct) =>
      adProduct.sovLowerRange <= randNum && adProduct.sovUpperRange >= randNum,
  );

function useAdProducts() {
  const queryInfo = useQuery(QUERY_KEYS.AD_PRODUCTS, () =>
    client.getAdProducts(),
  );

  return { ...queryInfo, adProducts: queryInfo.data ?? [] };
}

function useAdProductsOfType(type) {
  const { adProducts: allAdProducts, ...queryInfo } = useAdProducts();
  return {
    ...queryInfo,
    adProducts: allAdProducts?.filter((adProduct) => adProduct.type === type),
  };
}

function useRotatedAdProductOfType(type) {
  const randNumRef = useRef(random(1, 100));

  const { adProducts: adProductsOfType, ...queryInfo } = useAdProductsOfType(
    type,
  );

  return {
    ...queryInfo,
    adProduct: getRotatedAdProduct(adProductsOfType, randNumRef.current),
  };
}

export {
  useAdProducts,
  useAdProductsOfType,
  useRotatedAdProductOfType,
  getRotatedAdProduct,
};
